import { z } from 'zod';
import { formatToPascalCase } from '../../../../../react-commons/utils/utilFunctions';
import { showNotification } from '../../../ui/util/showNotification';
import { ResourceType } from '../../enumerations/ResourceType';
import { MutationErrorResponse, MutationErrorResponseSchema } from '../../resources/validation/errorResponseResource';
import { noop } from '@mantine/core';

// TODO parse in production!
export const parseRawData = <I>(rawData: unknown, schema: z.Schema<I, unknown>): I => {
    const result = schema.safeParse(rawData);

    if (result.success) {
        return result.data;
    } else {
        console.error('ZodError', { receivedObject: rawData, issues: result.error.issues });
        throw result.error; // do not turn this off, sync FE & BE instead!
    }
};

// TODO should this throw an error?
const onUnauthorizedShared = <E>(response: Response, returnValue: E, navigateToLogoutPage: () => void) => {
    const handleUnauthorized = (response: MutationErrorResponse | null) => {
        if (response?.type === 'ILLEGAL_AUTHENTICATION_TOKEN') {
            showNotification({
                severity: 'error',
                title: `Unauthorized: ${formatToPascalCase(response.type)}`,
                validationResourceType: ResourceType.NONE,
            });
            navigateToLogoutPage();
        } else if (response?.type) {
            if (response.right) {
                showNotification({
                    severity: 'error',
                    title: `Unauthorized: ${formatToPascalCase(response.type)} - ${formatToPascalCase(response.right)}`,
                    validationResourceType: ResourceType.NONE,
                });
            } else {
                showNotification({
                    severity: 'error',
                    title: `Unauthorized: ${formatToPascalCase(response.type)}`,
                    validationResourceType: ResourceType.NONE,
                });
            }
        } else {
            showNotification({
                id: 'expired_api_token',
                severity: 'error',
                title: 'Unauthorized: API Token has expired, please login',
                validationResourceType: ResourceType.NONE,
            });
            navigateToLogoutPage();
        }
    };

    return response
        .json()
        .then((rawData) => parseRawData(rawData, MutationErrorResponseSchema))
        .then((value) => {
            handleUnauthorized(value);
            return returnValue;
        })
        .catch(() => {
            handleUnauthorized(null);
            return returnValue;
        });
};

export const onUnauthorizedWithoutHook = <E>(response: Response, returnValue: E) => {
    return onUnauthorizedShared(
        response,
        returnValue,
        noop // TODO () => window.location.assign(`/logged-out?redirect=${location.pathname}${location.search}`)
    );
};

export const useOnUnauthorized = () => {
    // const navigate = useMyNavigate();
    // const { pathname, search } = useLocation();

    return <E>(response: Response, returnValue: E) =>
        onUnauthorizedShared(
            response,
            returnValue,
            noop // TODO () => navigate({ route: '/logged-out', searchParams: { redirect: `${pathname}${search}` }, })
        );
};

export const evaluateGetAllResult = <R>(result: Response, resourceSchema: z.Schema<R>): Promise<Array<R> | null> => {
    if (result.status !== 200) {
        throw Error('Http status was not 200!');
    }
    return result.json().then((resources) => parseRawData(resources, resourceSchema.array()));
};
